var _excluded = ["backgroundColor", "children", "fontColor", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
var AgroLabel = withCssProps(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    fontColor = _ref.fontColor,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Label, _extends({
    backgroundColor: backgroundColor,
    fontColor: fontColor,
    variant: variant
  }, props), children);
});
AgroLabel.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  fontColor: PropTypes.string,
  variant: PropTypes.oneOf(['custom', 'danger', 'info', 'primary'])
};
AgroLabel.displayName = 'AgroLabel';
export { AgroLabel };
var Label = styled.div.withConfig({
  displayName: "AgroLabel__Label",
  componentId: "sc-10ed41-0"
})(["display:inline-flex;justify-content:center;align-items:center;padding:1px 8px;font-weight:500;font-size:12px;line-height:18px;border-radius:28px;letter-spacing:-0.1px;font-family:", ";", " ", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  return variant === 'primary' && css(["background:", ";color:", ";"], theme.colors.green600, theme.colors.white);
}, function (_ref4) {
  var variant = _ref4.variant,
    theme = _ref4.theme;
  return variant === 'info' && css(["background:", ";color:", ";"], theme.colors.blue50, theme.colors.blue900);
}, function (_ref5) {
  var variant = _ref5.variant,
    theme = _ref5.theme;
  return variant === 'danger' && css(["background:", ";color:", ";"], theme.colors.red500, theme.colors.white);
}, function (_ref6) {
  var variant = _ref6.variant,
    backgroundColor = _ref6.backgroundColor,
    fontColor = _ref6.fontColor;
  return variant === 'custom' && css(["background:", ";color:", ";"], backgroundColor, fontColor);
});